//import { actionTypes } from '../actions/params';

// DEFAULT STATE
export const initParams = {
  "apiURL": ""
};

// WRITES
const params = (state, action) => {
  if(state === undefined) {
    return {};
  }
  return state
}

// READS
export const getApiUrl = state => state.params.apiURL;
export const getVersion = state => state.params.version;
export default params;


// WEBPACK FOOTER //
// ./src/reducers/params.js